<template>
    <div
        :class="[
            'user-icon',
            sizeClass,
        ]"
        :style="userIconStyle">
        <span>{{ firstInitial }}</span>
    </div>
</template>

<script>
import { calculateUsernameColor, formatUserFullName } from '@utils/user-settings';
import useUiVersion from '@/common/use/use-ui-version/use-ui-version';
import useDarkMode from '@/common/use/use-dark-mode/use-dark-mode';

export default {
    name: 'UserIcon',
    props: {
        user: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            default: '',
        },
    },
    compatConfig: {
        INSTANCE_LISTENERS: false,
    },
    setup () {
        const { isNewUi } = useUiVersion();
        const { isPendoDarkMode } = useDarkMode();

        return {
            isNewUi,
            isPendoDarkMode,
        };
    },
    computed: {
        userIconStyle () {
            return calculateUsernameColor(this.user.username, this.isNewUi, this.isPendoDarkMode);
        },
        firstInitial () {
            return formatUserFullName(this.user)
                .charAt(0)
                .toUpperCase();
        },
        sizeClass () {
            if (this.size === 'small') return 'small';

            return null;
        },
    },
};
</script>

<style scoped lang="less">
.user-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 500;
    height: 32px;
    width: 32px;
    border-width: 1.5px;
    border-style: solid;

    &.small {
        height: 20px;
        min-height: 20px;
        width: 20px;
        min-width: 20px;
        font-size: 10px;
    }
}
</style>
